/* @flow */
import cx from 'classnames';
import React from 'react';

import tooltipable from 'lib/tooltipable';
import ClickEventTrigger from 'components/ClickEventTrigger.jsx';
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import LinkBase from 'components/LinkBase.jsx';

import './styles/Link.scss';

const Link = React.createClass({
  propTypes: {
    bar: React.PropTypes.bool,
    children: React.PropTypes.node,
    className: React.PropTypes.string,
    color: React.PropTypes.oneOf([
      'lava',
      'jungle',
      'shamrock',
      'brand',
      'violet',
      'pitch',
      'eclipse',
      'thunder',
      'white',
      'inherit',
      'sunrise',
    ]),
    weight: React.PropTypes.oneOf([
      'normal',
      'semibold',
    ]),
    disabled: React.PropTypes.bool,
    block: React.PropTypes.oneOfType([
      React.PropTypes.bool,
      React.PropTypes.oneOf(['inline']),
    ]),
    noWrap: React.PropTypes.bool,
    rel: React.PropTypes.string,
    target: React.PropTypes.string,
    ...LinkBase.propTypes,
  },

  statics: {
    propClasses: {
      color: {
        lava: 'Link-lava',
        jungle: 'Link-jungle',
        shamrock: 'Link-shamrock',
        brand: 'Link-brand',
        violet: 'Link-violet',
        pitch: 'Link-pitch',
        eclipse: 'Link-eclipse',
        thunder: 'Link-thunder',
        white: 'Link-white',
        inherit: 'Link-inherit',
        sunrise: 'Link-sunrise',
      },
      noWrap: 'Link--noWrap',
      weight: {
        normal: 'Link--normal',
        semibold: 'Link--semibold',
      },
    },
  },

  render() {
    const { bar, block, disabled, children, className, rel, target, ...props } = this.props;
    const targetBlankRel = 'noopener noreferrer';
    let safeRel = null;

    if (rel && target === '_blank') {
      safeRel = `${rel} ${targetBlankRel}`;
    } else if (target === '_blank') {
      safeRel = targetBlankRel;
    }

    return (
      <ClickEventTrigger eventElementName={this.props.eventElementName}>
        <LinkBase
          {...props}
          rel={safeRel}
          target={target}
          className={cx('Link', {
            'Link-bar': bar,
            'Link-disabled': disabled,
            'Link-block': block === true,
            'Link-inlineBlock': block === 'inline',
          }, getPropClassesFromInstance(this), className)}
          disabled={disabled}>
          {children}
        </LinkBase>
      </ClickEventTrigger>
    );
  },
});

export default tooltipable(Link);



// WEBPACK FOOTER //
// ./src/components/Link.jsx